import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import "./Header.css";

const Header: React.FC = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  const isActive = (path: string) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  if (!user) return null;

  return (
    <>
      <header className="header-container">
        <div className="header-content">
          {/* Logo/Brand */}
          <div className="header-brand">
            <Link to="/" className="header-logo-link">
              <span className="header-logo-icon">🎨</span>
              <span className="header-logo-text">D'Asaro</span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="header-nav-desktop">
            <Link
              to="/"
              className={`header-nav-link ${isActive("/") ? "active" : ""}`}
              title="Dashboard"
            >
              🏠
            </Link>
            <Link
              to="/artworks"
              className={`header-nav-link ${
                isActive("/artworks") ? "active" : ""
              }`}
              title="Artworks"
            >
              📋
            </Link>
            <Link
              to="/add-artwork"
              className={`header-nav-link ${
                isActive("/add-artwork") ? "active" : ""
              }`}
              title="Add Artwork"
            >
              ➕
            </Link>
            <Link
              to="/next-actions"
              className={`header-nav-link ${
                location.pathname === "/next-actions" ? "active" : ""
              }`}
              title="Next Actions"
            >
              ⏭️
            </Link>
          </nav>

          {/* Quick Actions */}
          <div className="header-quick-actions">
            <Link
              to="/add-artwork"
              className="header-quick-action-button"
              title="Quick Add Artwork"
            >
              <span>⚡</span>
              <span>Add</span>
            </Link>
          </div>

          {/* ✅ USER SECTION - DESKTOP E MOBILE DIVERSI */}
          <div className="user-section">
            {/* ✅ DESKTOP: Settings button */}
            <Link
              to="/settings"
              className="settings-btn desktop-only"
              title="Settings"
            >
              ⚙️
            </Link>

            {/* ✅ DROPDOWN SEMPLICE SEMPLICE */}
            <div className="user-dropdown-container">
              <button
                className="user-btn"
                onClick={() => {
                  console.log("Click! Current state:", showUserMenu);
                  setShowUserMenu(!showUserMenu);
                }}
              >
                <span className="user-avatar">
                  {user.email?.[0]?.toUpperCase() || "U"}
                </span>
                <span className="user-name">
                  {user.email?.split("@")[0]?.substring(0, 6) || "User"}
                </span>
                <span>{showUserMenu ? "▲" : "▼"}</span>
              </button>

              {/* ✅ MENU BRUTALMENTE SEMPLICE */}
              <div className={`user-menu ${showUserMenu ? "show" : "hide"}`}>
                <div className="user-info">
                  <div>
                    <strong>{user.email?.split("@")[0]}</strong>
                  </div>
                  <div>
                    <small>{user.email}</small>
                  </div>
                </div>
                <hr />
                <Link to="/settings" onClick={() => setShowUserMenu(false)}>
                  ⚙️ Settings
                </Link>
                <button
                  onClick={() => {
                    handleLogout();
                    setShowUserMenu(false);
                  }}
                >
                  🚪 Logout
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="mobile-menu-btn"
          >
            ☰
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="mobile-menu">
            <Link to="/" onClick={() => setIsMenuOpen(false)}>
              🏠 Dashboard
            </Link>
            <Link
              to="/artworks"
              onClick={() => setIsMenuOpen(false)}
              className={isActive("/artworks") ? "active" : ""}
            >
              📋 View All Artworks
            </Link>
            <Link to="/add-artwork" onClick={() => setIsMenuOpen(false)}>
              ➕ Add Artwork
            </Link>
            <Link to="/next-actions" onClick={() => setIsMenuOpen(false)}>
              ⏭️ Next Actions
            </Link>
            <Link to="/settings" onClick={() => setIsMenuOpen(false)}>
              ⚙️ Settings
            </Link>
            <hr />
            <button
              onClick={() => {
                handleLogout();
                setIsMenuOpen(false);
              }}
            >
              🚪 Logout
            </button>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
